import { NewBadge } from "@components/common/new-badge";
import { SphereTooltip } from "@components/common/sphere-tooltip";
import { useTokenPurchase } from "@hooks/use-token-purchase";
import { NewCreditTooltip } from "@pages/settings/subscription-settings/credits/new-credit-tooltip";

/** Renders a dot icon as badge indicating newly purchased credit */
export function NewCreditBadge(): JSX.Element | null {
  const { shouldShowNewIndication } = useTokenPurchase();

  if (!shouldShowNewIndication) {
    return null;
  }

  return (
    <SphereTooltip title={<NewCreditTooltip />}>
      <NewBadge sx={{ right: "15px", cursor: "pointer" }} />
    </SphereTooltip>
  );
}
